import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import {
  ArticleCount,
  CardContainer,
  CountryName,
  FlagContainer,
  DisabledOverlay,
  WatermarkText,
} from './styles/CountryCard.styles';

interface CountryCardProps {
  name: string;
  countryCode: string;
  articleCount: number;
  slug: string;
  disabled?: boolean;
}

const CountryCard: React.FC<CountryCardProps> = ({
  name,
  countryCode,
  articleCount,
  slug,
  disabled,
}) => {
  return (
    <CardContainer
      to={disabled ? '#' : `/international/${slug}`}
      $disabled={disabled}
    >
      {disabled && (
        <DisabledOverlay>
          <WatermarkText>בקרוב!</WatermarkText>
        </DisabledOverlay>
      )}
      <FlagContainer>
        <ReactCountryFlag
          countryCode={countryCode}
          svg
          style={{
            width: '100px',
            height: '100px',
          }}
          title={name}
        />
      </FlagContainer>
      <CountryName>{name}</CountryName>
      {articleCount > 0 ? (
        <ArticleCount>
          {articleCount} {articleCount === 1 ? 'מאמר' : 'מאמרים'}
        </ArticleCount>
      ) : (
        <ArticleCount>{'המאמרים בקרוב'}</ArticleCount>
      )}
    </CardContainer>
  );
};

export default CountryCard;
